<template>
    <!--文档-->
    <div class="wordbox" v-loading="loading">
        <headerbox :focus="2"></headerbox>
        <!-- <div class="imgboxfather">
            <div class="imgbox">
            </div>
            <div class="search">
                <el-input placeholder="请使用关键词进行搜索" style=""></el-input>
                <div class="searchs">
                    <i class="el-icon-search"></i>
                </div>
            </div>
        </div>-->
        <div class="fixedcolor"></div>
        <div class="left">
      <!--      <div class="left">
                <div class="lefts">
                    <span>用户手册</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
                <div class="lefts">
                    <span class="leftspan">用户手册</span>
                </div>
            </div>-->
            <iframe src="http://help.idalc.com/doku.php" id="mobs"  frameborder="0"></iframe>
        </div>
       <!-- <el-popover
                placement="top-start"
                title="标题"
                width="200"
                trigger="hover"
                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
            <el-button slot="reference">hover 激活</el-button>

        </el-popover>-->
        <div class="wechat">

            <img class="wechatimg" src="../../public/statics/img/icon_xiaoxi.png" alt="" @click="toshowchat()">


            <div class="wechatform" v-show="showchat==true" ref="treeWrap">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <div class="unit">
                        <div class="units">
                            <!--  <span>*</span>-->
                            <p>手机号:</p>
                        </div>
                        <el-form-item prop="name">
                            <el-input v-model="ruleForm.name" placeholder="请输入姓名" style="width: 200px;"></el-input>
                        </el-form-item>
                    </div>
                    <div class="unit">
                        <div class="units">
                            <!--  <span>*</span>-->
                            <p>电话:</p>
                        </div>
                        <el-form-item prop="phone">
                            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" style="width: 200px;"></el-input>
                        </el-form-item>
                    </div>
                    <div class="unit">
                        <div class="units">
                            <!--  <span>*</span>-->
                            <p>邮箱:</p>
                        </div>
                        <el-form-item prop="email">
                            <el-input v-model="ruleForm.email" placeholder="请输入邮箱" style="width: 200px;"></el-input>
                        </el-form-item>
                    </div>
                    <div class="unit">
                        <el-form-item prop="content">
                            <el-input type="textarea" :autosize="{minRows: 5}" v-model="ruleForm.content"
                                      placeholder="请再次输入留言内容,我们会尽快与您联系!(必填)" style="width: 200px;"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item prop="content">
                        <el-button type="primary" style="width: 200px;" @click="subs()">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>

        </div>
        <botbox></botbox>
    </div>

</template>

<script>
    import {auth, anth} from '../request/api';
    import headerbox from "../components/boxtop";
    import botbox from "../components/botts";


    export default {
        name: "word",
        components: {
            headerbox: headerbox,botbox

        },
        data() {
            return {
                loading:true,
                ruleForm: {
                    name: "",
                },
                rules: {
                    name: [
                        {required: true, message: '请输入名字', trigger: 'blur'},
                    ],
                },
                showchat: false,
            }
        },
        mounted() {
          /*  document.addEventListener('mouseup',(e) =>{
                let tree = this.$refs.treeWrap
                if (tree) {
                    if (!tree.contains(e.target)) {
                        this.showchat =false
                    }
                }
            });*/
            setTimeout(()=>{
                this.loading=false;
            },300)

            this.getnows();
        },
        methods: {
            toshowchat() {
                this.showchat = !this.showchat;
            },
            subs(){
                this.showchat=false;
            },
            getnows(){

            },
        },
    }
</script>

<style scoped lang='scss'>
    .wordbox {
        width: 100%;
        height: 100vh;

        .imgboxfather {

            position: relative;
            background: #838695;
            .imgbox {
                width: 100%;
                height: 3.75rem;
                background-image: url("../../public/statics/img/img_wendang.jpg");
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center;

            }

            .search {
                position: absolute;
                left: 0;
                right: 0;
                width: 6rem;
                top: 2rem;
                margin: auto;
                display: flex;
                align-items: center;

                .searchs {
                    width: 80px;
                    height: 40px;
                    border-radius: 0 4px 4px 0;
                    background: #4f8aff;
                   /* margin-left: -0.1rem;*/
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 24px;
                    color: #ffffff;
                    cursor: pointer;
                    z-index: 99;
                }
                .searchs:active{
                    opacity: 0.9;
                }
            }
        }

        .wechat {
            position: fixed;
            right: 10px;
            bottom: calc(0.6rem + 10px);
            background: #fff;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 9999;

            .wechatimg {
                width: 60%;
                height: 60%;
            }

            .wechatform {
                position: absolute;
                width: 200px;
                background: #fff;
                padding: 20px;
                bottom: 50px;
                right: 30px;
                border-radius: 6px;
                box-shadow: 1px 0px 10px -2px rgba(42, 39, 39, 0.75);
                -webkit-box-shadow: 1px 0px 10px -2px rgba(42, 39, 39, 0.75);
                -moz-box-shadow: 1px 0px 10px -2px rgba(42, 39, 39, 0.75);

                .unit {
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;

                    .units {
                        font-size: 14px;
                        font-family: "PingFang SC";
                        line-height: 24px;
                        color: #606266;
                        display: flex;
                        margin-bottom: 5px;

                        span {
                            color: #F35959;
                            margin-right: 5px;
                        }

                        p {
                        }

                    }
                }
            }
        }
        .fixedcolor{
            width: 100%;
            height: 0.6rem;
            background: #2c3e50;
            position: fixed;
            top: 0;
        }

        .left{

            /*width: 24rem;*/
            width:100%;
            background:#fbfaf9;
            height: 100%;
            line-height: 40px;
            #mobs{
                /*width:calc(100% - 20px);*/
                width: 100%;
                /*height: 100%;*/
                /*height: calc(100% - 0.6rem);*/
                min-height: 800px;
                overflow-y: scroll;
                box-sizing: border-box;
                margin-top: calc(0.6rem - 27px);
            }

/*
            .lefts{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                span{
                    margin-left: 50px;
                    margin-right:50px;
                    font-family: "PingFang SC";
                    font-size: 16px;
                }
                i{
                    font-size: 16px;
                    font-family: "PingFang SC";
                    font-weight: bold;
                }
            }*/
        }

    }
</style>
<style lang="scss">
    .wordbox {
        .el-input__inner {
            background: #f7f7f7;
        }

        .el-textarea__inner {
            background: #f7f7f7;
        }
        .search{
            .el-input__inner{
                border-radius: 4px 0 0 4px;
            }
        }
    }


</style>